import apiClient from '../api/api';

export interface UserActivityReport {
  _id: string;
  user_id: string;
  event_type: string;
  event_time: string;
  event_description: string;
  action_by: string;
  meta_data?: any;
  action_by_info?: any; // Resolved user info from the backend
  createdAt: string;
  updatedAt: string;
}

export interface UserActivityReportListParams {
  skip: number;
  limit: number;
  user_id?: string;
  event_type?: string;
  action_by?: string;
  start_date?: string;
  end_date?: string;
  email?: string;
}

export interface UserActivityReportListResponse {
  success: boolean;
  code: number;
  data: {
    data: {
      total_count: number;
      user_activity_reports: UserActivityReport[];
    }
  };
}

class UserActivityReportService {
  // POST: Fetch user activity reports with pagination and filters
  async getUserActivityReports(params: UserActivityReportListParams): Promise<{
    total_count: number;
    user_activity_reports: UserActivityReport[];
  }> {
    try {
      const response = await apiClient.post<any>('/dms-v2-srv/user-srv/user-activity/list', params);

      const payload = response?.data?.data ?? response?.data;
      if (payload && typeof payload.total_count === 'number') {
        return {
          total_count: payload.total_count,
          user_activity_reports: payload.user_activities || payload.user_activity_reports || []
        };
      }
      return {
        total_count: 0,
        user_activity_reports: []
      };
    } catch (error) {
      console.error('Error fetching user activity reports:', error);
      throw error;
    }
  }

  // Helper to format event types into readable text
  formatEventTypeLabel(eventType: string): string {
    return eventType
      .replace(/_/g, ' ')
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}

export const userActivityReportService = new UserActivityReportService();
